// reducer.js
import {
  SET_VALUE_Pindu,
  SET_TYPE_Pindu,
  SET_CURRENT_PAGE_Pindu,
  SET_ORDER_Pindu,
  SET_SORT_FIELD_Pindu,
  SET_ACTIF_Pindu,
} from "./actionsTypes";

const initialState = {
  value: "",
  type: "",
  actif: "",
  currentPage: 1,
  order: "asc",
  sortField: "nom",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VALUE_Pindu:
      return {
        ...state,
        value: action.payload,
      };
    case SET_TYPE_Pindu:
      return {
        ...state,
        type: action.payload,
      };

    case SET_CURRENT_PAGE_Pindu:
      return {
        ...state,
        currentPage: action.payload,
      };
    case SET_ORDER_Pindu:
      return {
        ...state,
        order: action.payload,
      };
    case SET_SORT_FIELD_Pindu:
      return {
        ...state,
        sortField: action.payload,
      };
    case SET_ACTIF_Pindu:
      return {
        ...state,
        actif: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
